//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailsTime',
  props: {
    createTime: { type: [String, Number], default: '' },
    updateTime: { type: [String, Number], default: '' },
  },
};
